import * as types from './types'

export const updateCustomerEmail = (emailValue) => ({
  type: types.UPDATE_CUSTOMER_EMAIL,
  emailValue,
})

export const updateCustomerInfo = (infos) => ({
  type: types.SET_CUSTOMER_INFO,
  infos,
})

export const updateAPIActionFeedback = (message) => ({
  type: types.SET_API_ACTION_FEEDBACK_PROFILE,
  message,
})

export const verifyCustomerEmailAddress = () => ({
  type: types.EMAIL_EXISTS_STATUS,
  customerEmailExists: true,
})

export const emailVerificationInProgess = (status) => ({
  type: types.EMAIL_STATUS_VERIFYING,
  emailVerificationInProgess: status,
})

export const invalidateVerifiedEmail = () => ({
  type: types.EMAIL_EXISTS_STATUS,
  customerEmailExists: false,
})
